var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "navbar is-white", attrs: { id: "store-navbar" } },
    [
      !_vm.isLoaded()
        ? _c("BaseLoader", { attrs: { type: "menu" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoaded()
        ? _c(
            "div",
            { staticClass: "navbar-menu is-active" },
            [
              !_vm.loggedIn || !_vm.hasCustomerInfo()
                ? [
                    _c("div", { staticClass: "navbar-start" }, [
                      _c("div", { staticClass: "navbar-item item-login" }, [
                        _c(
                          "p",
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$appConstants.loginInquiry) + " "
                            ),
                            _c("br"),
                            _vm._v(" "),
                            !_vm.isInjectable()
                              ? _c(
                                  "a",
                                  {
                                    attrs: { tabindex: "0" },
                                    on: {
                                      keydown: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.setModal("login")
                                      },
                                      click: function($event) {
                                        return _vm.setModal("login")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    Login or Sign-up\n                                "
                                    )
                                  ]
                                )
                              : _c(
                                  "navigation-route",
                                  {
                                    attrs: {
                                      tabindex: "0",
                                      link: _vm.baseURL + "login",
                                      isVueRoute: !_vm.isInjectable()
                                    },
                                    on: {
                                      keydown: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.setModal("login")
                                      },
                                      click: function($event) {
                                        return _vm.setModal("login")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    Login or Sign-up\n                                "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "navbar-item" }, [
                      _c(
                        "div",
                        { staticClass: "navbar-item center-nav-item" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "has-text-centered",
                              attrs: { id: "location-data" }
                            },
                            [_c("navigation-location-mobile")],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "navbar-end" }, [
                      _c(
                        "div",
                        { staticClass: "navbar-item" },
                        [
                          _vm.appIsLoaded && _vm.itemCount
                            ? _c(
                                "navigation-route",
                                {
                                  key: _vm.itemCount,
                                  attrs: {
                                    target: "_parent",
                                    link: _vm.baseURL + "checkout",
                                    isVueRoute: !_vm.isInjectable(),
                                    classes:
                                      "button button--checkout is-rounded nav-btn"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tCheckout\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "item-count-background" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "item-count" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.itemCount) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _c(
                                "p",
                                { staticClass: "loyalty-earnings-message" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\tEarn\n\t\t\t\t\t\t\t\t"
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "loyalty-pill store-loyalty-color bold-txt"
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$appConstants.loyaltyEarnings
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\twith each order\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                        ],
                        1
                      )
                    ])
                  ]
                : [
                    _c("div", { staticClass: "navbar-start" }, [
                      _c("div", { staticClass: "navbar-item" }, [
                        _c(
                          "div",
                          { staticClass: "slide-out-container" },
                          [_c("SlideoutMenu")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "is-hidden-tablet-only profile-info-container"
                          },
                          [
                            _c(
                              "p",
                              [
                                _vm.customer.firstName || _vm.customer.lastName
                                  ? [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\tHi,\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "store-navigation-color",
                                          attrs: { href: "/?profile" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.setModal("profile")
                                            }
                                          }
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.customer.firstName ||
                                                  _vm.customer.lastName
                                              ) + "!"
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  : _c(
                                      "a",
                                      {
                                        staticClass: "store-navigation-color",
                                        on: {
                                          click: function($event) {
                                            return _vm.setModal("profile")
                                          }
                                        }
                                      },
                                      [_c("strong", [_vm._v("Edit Profile")])]
                                    ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _vm.hasCouponOffers()
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "loyalty-offer-message",
                                        on: {
                                          click: function($event) {
                                            return _vm.setModal("loyalty")
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\tOffers Available\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.hasCouponOffers()
                                  ? _c("span", [_vm._v("You've earned")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "store-loyalty-color",
                                    attrs: {
                                      href: "/?loyalty",
                                      "aria-label": "show loyalty details"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.setModal("loyalty")
                                      }
                                    }
                                  },
                                  [
                                    _c("strong", [
                                      _c(
                                        "span",
                                        { staticClass: "loyalty-pill" },
                                        [_vm._v(_vm._s(_vm.displayLoyalty))]
                                      )
                                    ]),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$appConstants.pointsName) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "navbar-item center-nav-item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "has-text-centered",
                          attrs: { id: "location-data" }
                        },
                        [_c("navigation-location-mobile")],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "navbar-end has-text-centered-tablet-only"
                      },
                      [
                        _vm.appIsLoaded && _vm.itemCount
                          ? _c(
                              "navigation-route",
                              {
                                attrs: {
                                  target: "_parent",
                                  link: _vm.baseURL + "checkout",
                                  isVueRoute: !_vm.isInjectable(),
                                  classes:
                                    "button button--checkout is-rounded nav-btn"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Checkout \n                                "
                                ),
                                _c(
                                  "div",
                                  { staticClass: "item-count-background" },
                                  [
                                    _c("span", { staticClass: "item-count" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(_vm.itemCount) +
                                          "\n                                    "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5753ffd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5753ffd4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Navigation.vue
// module id = null
// module chunks = 